import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { MaterialModule } from 'src/app/shared/material.module';
import { RouterModule } from '@angular/router';

import { LoginLayoutComponent, MainLayoutComponent, NavbarComponent, NotAuthorizedComponent, NotFound404Component, ToolbarComponent } from './components';
import { SidenavService } from './services';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AuthTokenInterceptor } from './routing/auth-token.interceptor';
import { OfflineComponent } from './components/offline/offline.component';
import { SharedModule } from 'app/shared/shared.module';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';


@NgModule({
    declarations: [
        LoginLayoutComponent,
        MainLayoutComponent,
        NavbarComponent,
        NotAuthorizedComponent,
        NotFound404Component,
        ToolbarComponent,
        OfflineComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        // MaterialModule,
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTooltipModule,
        RouterModule,
        HttpClientModule,
        FlexLayoutModule,
        SharedModule,
    ],
    providers: [
        SidenavService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    ],
})
export class CoreModule { }
